import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

class Header extends Component {
    
    componentDidMount() {
        // if (sessionStorage.getItem("alertShow")) {
        //     let alertButton = document.getElementById('alertButton');
        //     alertButton.remove();
        // }
    }

    render() {
        let showMobileMenu = () => {
            let mobileNav = document.getElementById('mobile-nav');
            mobileNav.style.display = 'flex';
        };

        let closeMobileMenu = () => {
            let mobileNav = document.getElementById('mobile-nav');
            mobileNav.style.display = 'none';
        };

        // let alertClick = () => {
        //     let alertButton = document.getElementById('alertButton');
        //     alertButton.style.display = 'none';
        //     sessionStorage.setItem("alertShow", true);
        // };

        return (
            <div className="Header-container">
                <div className="Header-infected"></div>
                {/* BUNKER LOGO */}
                <NavLink exact to="/">
                    <div className="Header-logo"></div>
                </NavLink>
                {/* BUY TICKETS */}
                <NavLink className="nav-link" exact to="/tickets">
                    <div className="Header-btn-tickets"></div>
                </NavLink>
                {/* NAVIGATION BAR */}
                <div className="Header-nav-container">
                    <NavLink className="nav-link" exact to="/">
                        <div className="Header-nav-item">HOME</div>
                    </NavLink>
                    <NavLink className="nav-link" exact to="/about">
                        <div className="Header-nav-item">ABOUT</div>
                    </NavLink>
                    <NavLink className="nav-link" exact to="/rooms">
                        <div className="Header-nav-item">ROOMS</div>
                    </NavLink>
                    {/* <NavLink className="nav-link" exact to="/directions">
                        <div className="Header-nav-item">DIRECTIONS</div>
                    </NavLink> */}
                    <NavLink className="nav-link" exact to="/groups">
                        <div className="Header-nav-item">PRIVATE EVENTS</div>
                    </NavLink>
                    <NavLink className="nav-link" exact to="/history">
                        <div className="Header-nav-item">HISTORY</div>
                    </NavLink>
                    {/* <NavLink className="nav-link" exact to="/press">
                        <div className="Header-nav-item">PRESS</div>
                    </NavLink>
                    <a
                        href="https://store13135006.ecwid.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="Header-nav-item">STORE</div>
                    </a> */}
                    {/* <a
                        href="mailto:thebunkerexperience@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="Header-nav-item">CONTACT</div>
                    </a> */}
                </div>
                {/* MOBILE MENU BUTTON */}
                <div className="Header-mobile-menu-btn" onClick={showMobileMenu}>
                    <div>MENU</div>
                </div>
                {/* MOBILE NAV */}
                <div id="mobile-nav" className="Header-mobile-nav-container">
                    <div className="Header-mobile-nav-close" onClick={closeMobileMenu}></div>
                    <div className="Header-mobile-nav-items">
                        <NavLink className="nav-link" exact to="/">
                            <div className="Header-mobile-nav-item">HOME</div>
                        </NavLink>
                        <NavLink className="nav-link" exact to="/tickets">
                            <div className="Header-mobile-nav-item">BUY TICKETS</div>
                        </NavLink>
                        <NavLink className="nav-link" exact to="/about">
                            <div className="Header-mobile-nav-item">ABOUT</div>
                        </NavLink>
                        <NavLink className="nav-link" exact to="/rooms">
                            <div className="Header-mobile-nav-item">ROOMS</div>
                        </NavLink>
                        {/* <NavLink className="nav-link" exact to="/directions">
                            <div className="Header-mobile-nav-item">DIRECTIONS</div>
                        </NavLink> */}
                        <NavLink className="nav-link" exact to="/groups">
                            <div className="Header-mobile-nav-item">PRIVATE EVENTS</div>
                        </NavLink>
                        <NavLink className="nav-link" exact to="/history">
                            <div className="Header-mobile-nav-item">HISTORY</div>
                        </NavLink>
                        {/* <NavLink className="nav-link" exact to="/press">
                            <div className="Header-mobile-nav-item">PRESS</div>
                        </NavLink> */}
                        {/* <a
                            className="nav-link"
                            href="https://store13135006.ecwid.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="Header-mobile-nav-item">STORE</div>
                        </a> */}
                        {/* <a
                            className="nav-link"
                            href="mailto:thebunkerexperience@gmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="Header-mobile-nav-item">CONTACT</div>
                        </a> */}
                    </div>
                </div>
                {/* <div className="alert-win" id="alertButton" onClick={alertClick}></div> */}
            </div>
        );
    }
}

export default Header;
